import type { CartProductType } from './schemas'

export const CART_PRODUCT_TYPE_KO = {
  SIGNATURE_WORKBOOK: '시그니처 교재',
  CUSTOM_WORKBOOK: '내 교재',
  PRINT_DOCUMENT: '책갈피',
} as const satisfies Record<CartProductType, string>

// 제본할 수 있는 쪽수 범위. 책등은 일정 쪽수 이상이어야 글자를 넣을 수 있다
export const MIN_ORDERABLE_PAGE_COUNT = 20
export const MAX_ORDERABLE_PAGE_COUNT = 450
export const MIN_PAGE_COUNT_FOR_BOOK_SPINE = 40
